const TWITTER_HANDLE_REGEX = /^[a-zA-Z0-9_]{1,15}$/;
const TWITTER_URL_REGEX = /^(?:https?:\/\/)?(?:www\.|mobile\.)?(?:twitter|x)\.com\/(?:#!\/)?@?([a-zA-Z0-9_]+)\/?(?:[?#].*)?$/i;

/**
 * Accepts a Twitter/X username in any common form and returns the bare handle:
 *   emretanriver_                  -> emretanriver_
 *   @emretanriver_                 -> emretanriver_
 *   https://x.com/emretanriver_    -> emretanriver_
 *   https://twitter.com/emretanriver_?s=21 -> emretanriver_
 * Returns null when the value is empty and undefined when it cannot be parsed
 * or the extracted handle is not a valid Twitter username.
 */
export const extractTwitterHandle = value => {
  if (value === null || value === undefined) {
    return null;
  }

  const trimmed = String(value).trim();

  if (!trimmed) {
    return null;
  }

  const urlMatch = trimmed.match(TWITTER_URL_REGEX);
  const handle = urlMatch ? urlMatch[1] : trimmed.replace(/^@/, '');

  return TWITTER_HANDLE_REGEX.test(handle) ? handle : undefined;
};

export const isValidTwitterHandle = value => extractTwitterHandle(value) !== undefined;

/**
 * Normalizes the twitter field before saving so the database always keeps
 * the bare username regardless of how the editor typed it. Invalid values
 * are left untouched so validation can still report them.
 */
export default function normalizeTwitterHandle(value) {
  const handle = extractTwitterHandle(value);

  return handle === undefined ? value : handle;
}
